<template>
  <div id="root-template">
    <div class="lotto-wrap">
      <div class="row">
        <div class="col-sm-8 lt-left-content">
          <div class="lt-left-inner">
            <div class="lt-input-wrap">
              <div class="lt-input" v-bind:value="currentNumber.charAt(0)">
                {{ currentNumber.charAt(0) ? currentNumber.charAt(0) : "&nbsp;" }}
              </div>
              <div class="lt-dat"><i class="dat-line"></i></div>
              <div class="lt-input" v-bind:value="currentNumber.charAt(1)">
                {{ currentNumber.charAt(1) ? currentNumber.charAt(1) : "&nbsp;" }}
              </div>
              <div class="lt-dat"><i class="dat-line"></i></div>
              <div class="lt-input" v-bind:value="currentNumber.charAt(2)">
                {{ currentNumber.charAt(2) ? currentNumber.charAt(2) : "&nbsp;" }}
              </div>
              <div class="lt-dat"><i class="dat-line"></i></div>
              <div class="lt-input" v-bind:value="currentNumber.charAt(3)">
                {{ currentNumber.charAt(3) ? currentNumber.charAt(3) : "&nbsp;" }}
              </div>
              <div class="lt-dat"><i class="dat-line"></i></div>
              <div class="lt-input" v-bind:value="currentNumber.charAt(4)">
                {{ currentNumber.charAt(4) ? currentNumber.charAt(4) : "&nbsp;" }}
              </div>
              <div class="lt-dat"><i class="dat-line"></i></div>
              <div class="lt-input" v-bind:value="currentNumber.charAt(5)">
                {{ currentNumber.charAt(5) ? currentNumber.charAt(5) : "&nbsp;" }}
              </div>
              <div class="clearfix"></div>
            </div>
            <!-- end -->
            <div class="lt-btn-pad-wrap">
              <div class="lt-btn-wrap pull-right">
                <button type="button" class="btn btn-red" v-bind:disabled="currentNumber.length <= 0"
                        v-on:click="currentNumber = currentNumber.substring(0, currentNumber.length - 1)">
                  {{$t("messages.deleteLast")}}
                </button>
                <button type="button" class="btn btn-orange" v-bind:disabled="disableBtnRandomNumber"
                        v-on:click="randomNumber()">{{$t("messages.randomNumber")}}
                </button>
                <button type="button" class="btn btn-green" v-on:click="createCartItemObject(selectPrice)"
                        v-bind:disabled="currentNumber.length < 6">{{$t("messages.select")}}
                </button>
              </div>
              <!-- end -->
              <div class="lt-numberpad pull-left">
                <div class="rows">
                  <button value="7" class="btn-numberpad" v-on:click="selectNumber(7)">7</button>
                  <button value="8" class="btn-numberpad" v-on:click="selectNumber(8)">8</button>
                  <button value="9" class="btn-numberpad" v-on:click="selectNumber(9)">9</button>
                </div>
                <div class="rows">
                  <button value="4" class="btn-numberpad" v-on:click="selectNumber(4)">4</button>
                  <button value="5" class="btn-numberpad" v-on:click="selectNumber(5)">5</button>
                  <button value="6" class="btn-numberpad" v-on:click="selectNumber(6)">6</button>
                </div>
                <div class="rows">
                  <button value="1" class="btn-numberpad" v-on:click="selectNumber(1)">1</button>
                  <button value="2" class="btn-numberpad" v-on:click="selectNumber(2)">2</button>
                  <button value="3" class="btn-numberpad" v-on:click="selectNumber(3)">3</button>
                </div>
                <div class="rows">
                  <button value="0" class="btn-numberpad zero" v-on:click="selectNumber(0)">0</button>
                </div>

              </div>
              <!-- end -->
            </div>
            <!-- end -->
            <div class="lt-radio-wrap">
              <div class="row">
                <div class="col-xs-12">
                  <div class="form-group">
                    <label for="price">กรุณากรอกราคาที่ท่านต้องการซื้อ</label>
                    <input name="price" class="form-control" v-model="selectPrice" type="number" min="0">
                  </div>
                </div>
                <!-- <div class="col-xs-6">
                  <p>
                    <input type="radio" id="test1" name="radio-group" v-model="selectPrice"
                           v-bind:value="betconfig.patternObj.bet_space_lottery.stake_min | number">
                    <label
                      for="test1">{{$t("messages.halfCard")}} {{betconfig.patternObj.bet_space_lottery.stake_min | number}}</label>
                  </p>
                </div>
                <div class="col-xs-6">
                  <p>
                    <input type="radio" id="test2" name="radio-group" v-model="selectPrice"
                           v-bind:value="betconfig.patternObj.bet_space_lottery.stake_max | number" checked>
                    <label
                      for="test2">{{$t("messages.fullCard")}} {{betconfig.patternObj.bet_space_lottery.stake_max | number}}</label>
                  </p>
                </div> -->
              </div>
            </div>
            <!-- end -->
            <div class="lt-btn-wrap">
            </div>
          </div>
        </div>
        <div class="col-sm-4 lt-right-content">
          <h2>{{$t("messages.listWaitConfirm")}}</h2>

          <div class="box-lt-comfirm">
            <table class="table font-19 table-hover">
            <thead>
            <tr>
              <th class="text-center">#</th>
              <th class="text-left">รายการ</th>
              <th class="text-left"><strong>{{ $t("messages.betPrice") }}</strong></th>
              <th class="text-left"></th>
            </tr>
            </thead>

            <tbody>
            <template v-for="(item,index) in cartItem">
              <tr>
                <td class="text-center">{{index + 1}}</td>
                <td style="font-weight:bold;letter-spacing:5px" class="text-left">{{ item.number }}</td>
                <td class="text-left">{{ item.price | number }}</td>
                <td><a href="javascript:void(0)" class="lt-remove" @click="removeCartItem(item)"><i class="fa fa-times"
                                                                                                    aria-hidden="true"></i></a></td>
              </tr>
            </template>
            <tr v-if="cartItem.length == 0">
                <td colspan="100%" class="text-center">{{ $t("messages.listEmpty") }}</td>
              </tr>
            </tbody>
            <tfoot v-if="cartItem.length > 0">
            <tr>
              <th class="text-right">
              </th>
              <th class="text-right">
                <strong>{{ $t("messages.total") }} :</strong>
              </th>
              <th class="text-left">
                <strong>{{ totalBetPrice | number }}</strong>
              </th>
              <th class="text-left">
              </th>
            </tr>
            </tfoot>
          </table>

          </div>


          <div class="clearfix"></div>

          <!-- end -->

          <div class="lt-radio-wrap">
            <div class="row">
              <div class="col-xs-6">
                <p>
                  <input type="radio" id="creditChip" value="2" v-model="stakeMethod">
                  <label for="creditChip">{{ $t("messages.creditChip") }}</label>
                </p>
              </div>
              <div class="col-xs-6">
                <p>
                  <input type="radio" id="rollingChip" value="1" v-model="stakeMethod" checked>
                  <label for="rollingChip">{{ $t("messages.rollingChip") }}</label>
                </p>
              </div>
            </div>
          </div>

          <div class="clearfix"></div>

          <div class="lt-btn-wrap lt-submit-form">
            <button type="button" class="btn btn-red" v-on:click="removeAllCartItems"
                    v-bind:disabled="cartItem.length == 0">ล้างข้อมูล
            </button>&nbsp;&nbsp;<button type="button" class="btn btn-green" v-on:click="confirmCheckout"
                                         v-bind:disabled="cartItem.length == 0">สั่งซื้อ
          </button>
          </div>

        </div>
      </div>
    </div>
    <div class="modal inmodal lt-btn-wrap" id="modal-confirm-checkout" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog ">
        <div class="modal-content animated fadeIn">
          <div class="modal-header" style="padding-bottom:15px">
            <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span
              class="sr-only">Close</span></button>
            <h4 class="modal-title">{{ $t("messages.reviewBeforeConfirm") }}</h4>
            <small class="font-bold font-19">{{ betconfig.period_title }}</small>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <table class="table font-19 no-border table-hover" v-for="resultGroup in cartGroupList()">
                <thead>
                <tr>
                  <th class="text-center txt-bold">#</th>
                  <th class="text-left txt-bold">รายการ</th>
                  <th class="text-left txt-bold"><strong>{{ $t("messages.betPrice") }}</strong></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(item,index) in resultGroup.data">
                  <tr :key="index">
                    <td class="text-center">{{index + 1}}</td>
                    <td style="font-weight:bold;letter-spacing:5px" class="text-left">{{ item.number }}</td>
                    <td class="text-left">{{ item.price | number }}</td>
                  </tr>
                </template>
                </tbody>
                <tfoot>
                <tr>
                  <th class="text-right">
                  </th>
                  <th class="text-right txt-bold">
                    <strong>{{ $t("messages.total") }} :</strong>
                  </th>
                  <th class="text-left txt-bold">
                    <strong>{{ totalBetPrice | number }}</strong>
                  </th>
                </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div v-if="offline">
          <div class="form-horizontal border-top p-sm">
            <div class="row">
              <div class="col-sm-12 text-left">
                <h3>ช่องทางการส่งข้อมูลการสั่งซื้อ <br/><small> <span class="text-danger">*</span> โปรดระบุอย่างน้อย 1 ช่องทาง</small> <small>(กรณีส่ง SMS ระบบจะส่งเพียงเลขที่รายการโพยเท่านั้น ไม่ส่งเลขที่แทง)</small>
                </h3>
              </div>

            </div>
            <div class="form-group">
              <label class="col-lg-2 control-label">SMS:</label>
              <div class="col-lg-10">
                <div class="input-group input-group-sm mb-3">
                  <span class="input-group-addon"  ><i class="fa fa-phone"></i></span>
                  <input type="text" style="width: 250px;" v-model="mobile"  placeholder="Mobile" maxlength="10" minlength="10" class="input-sm form-control"/>
                </div>
              </div>
              <br/><br/>
              <label class="col-lg-2 control-label">Email:</label>
              <div class="col-lg-10">
                <div class="input-group input-group-sm mb-3">
                  <span class="input-group-addon" ><i class="fa fa-envelope"></i></span>
                  <input type="text" style="width: 250px;" v-model="email" placeholder="Email" maxlength="80"  class="input-sm form-control"/>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div class="p-sm border-top text-center">
            <div class="row">
              <div class="col-xs-6">
                <button type="button" class="btn btn-red pull-right" data-dismiss="modal">
                  {{ $t("messages.cancel") }}
                </button>
              </div>

              <div class="col-xs-6">
                <button type="button" class="btn btn-green pull-left"
                        v-on:click="doConfirmCheckout(), disableBtn = true" v-bind:disabled="disableBtn || (offline && (!mobile && !email) ) "
                        v-html="disableBtn ? textSendStakeSetLoading:textSendStakeSet"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal inmodal lt-btn-wrap" id="modal-checkout-success" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content animated fadeIn">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span
              class="sr-only">Close</span></button>
            <h1><i class="fa fa-check text-navy" style="font-size:60px;color:#006725"></i></h1>
            <h4 class="modal-title">{{ $t("messages.systemSendedList") }}</h4>
          </div>
          <div class="modal-body p-sm border-bottom">
            <div  v-if="offline">
              <a :href="'/auto-lotto/print/'+slipNumber" target="_blank" class="btn btn-info pull-right btn-sm" ><i class="fa fa-print"></i> พิมพ์</a>
              <br/>
              <div class="clearfix"> </div>
              <h3 class="text-center" >{{ $t("messages.setNumber") }} #{{ slipNumber }} </h3>
            </div>
            <div v-else>
              <h3 class="text-center" >{{ $t("messages.setNumber") }} #{{ stakeSetId }} </h3>
            </div>

            <h3 class="text-center m-b-none">{{ betconfig.period_title }}</h3>
          </div>
          <table class="table font-19 table-hover">
            <thead>
            <tr>
              <th class="text-center">#</th>
              <th class="text-left">รายการ</th>
              <th class="text-left"><strong>{{ $t("messages.betPrice") }}</strong></th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(item,index) in resultCartItem">
              <tr>
                <td class="text-center">{{index + 1}}</td>
                <td style="font-weight:bold;letter-spacing:5px" class="text-left">{{ item.number }}</td>
                <td class="text-left">{{ item.price | number }}</td>
              </tr>
            </template>
            </tbody>
            <template v-if="errorItem.length > 0">
              <thead style="color: white; background-color: red;">
              <tr>
                <th class="text-center">#</th>
                <th class="text-left" width="50%">รายการที่เกิดข้อผิดพลาด</th>
                <th class="text-left"><strong>หมายเหตุ</strong></th>
              </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in errorItem"
                  :key="index"
                >
                <td class="text-center">{{index + 1}}</td>
                  <td style="font-weight:bold;letter-spacing:5px" class="text-left">{{ item.number }}</td>
                  <td class="text-left">
                    <small v-if="item.half">
                      {{ `เลข ${item.number} ได้ถูกซื้อไปแล้ว ${item.current} ใบ ครึ่ง สามารถซื้อได้ไม่เกิน 5 ใบ` }}
                    </small>
                    <small v-else>
                      {{ `เลข ${item.number} ได้ถูกซื้อไปแล้ว ${item.current} ใบ สามารถซื้อได้ไม่เกิน 5 ใบ` }}
                    </small>
                  </td>
                </tr>
              </tbody>
            </template>
            <tfoot>
            <tr>
              <th class="text-right">
              </th>
              <th class="text-right">
                <strong>{{ $t("messages.total") }} :</strong>
              </th>
              <th class="text-left">
                <strong>{{ resultTotalBetPrice | number }}</strong>
              </th>
            </tr>
            </tfoot>
          </table>
          <div class="p-sm border-top text-center">
            <div class="row">
              <div class="col-xs-6 ">
                <button type="button" @click="reportUrl"
                        class="btn btn-orange pull-right"><i
                  class="fa fa-fw fa-list-ol"></i> {{ $t("messages.viewListing") }}
                </button>

              </div>
              <div class="col-xs-6">
                <button type="button" class="btn btn-green pull-left" data-dismiss="modal"><i
                  class="fa fa-fw fa-sign-in"></i> {{ $t("messages.continue") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapGetters, mapActions } from 'vuex'

  export default {
    props: {
      maxbet: {
        type: [String, Number],
      },
      betconfig: {
        type: Object,
        default: () => ({}),
      },
      offline: {
        type: Boolean,
      },
    },
    name: 'game',
    data: function () {
      return {
        textSendStakeSet: '<i class="fa fa-check"></i>' + this.$t('messages.sendList'),
        textSendStakeSetLoading: '<i class="fa fa-circle-o-notch fa-spin fa-fw"></i> ' + this.$t('messages.sending'),
        numberList: null,
        disableBtnRandomNumber: false,
        currentNumber: '',
        showModalConfirmCheckout: null,
        stakeMethod: 2,
        selectPrice: 0,
        searchNumber: null,
        mobile:null,
        email:null,
        validateOffline:false,
        forcePrice: null,
        disableBtn: false,
        numberSetPickupList: null,
        stakeSetPickupList: null,
        currentMainTypeActive: 1,
        permArr: [],
        usedChars: [],
        // cartItem: [],
        resultCartItem: [],
        errorItem: [],
        showModalConfirm: false,
        showModalConfirmDismissible: true,
        loadingSubmit: false,
        showConfirmClearData: false,
        validBetPriceList: [],
        currentTab3: 1,
        pricelist: [],
        stakeSetId: null,
        slipNumber:null,
        betDetails: {
          1: {
            name: this.$t('games.lotto'),
            slug: 'bet_space_lottery',
            rewardPrice: this.betconfig.patternObj.bet_space_lottery.rate,
            minimumBetPrice: this.betconfig.patternObj.bet_space_lottery.stake_min,
            maximumBetPrice: this.betconfig.patternObj.bet_space_lottery.stake_max,
            maximumBetPricePerNumber: this.betconfig.patternObj.bet_space_lottery.stake_number_limit,
            maximumNumberQuantityPerList: this.betconfig.patternObj.bet_space_lottery.accept_stake_count,
          }
        }
      }
    },
    computed: {
      ...mapState('betting', {
        cartItem: 'stakes'
      }),
      totalBetPrice: function () {
        var sum = 0
        for (var key in this.cartItem) {
          if (this.cartItem.hasOwnProperty(key)) {
            sum += parseFloat(this.cartItem[key].price)
          }
        }
        return sum
      },
      resultTotalBetPrice: function () {
        var sum = 0
        for (var key in this.resultCartItem) {
          if (this.resultCartItem.hasOwnProperty(key)) {
            sum += parseFloat(this.resultCartItem[key].price)
          }
        }
        return sum
      },
      resultTotalRewardPrice: function () {
        var sum = 0
        for (var key in this.resultCartItem) {
          if (this.resultCartItem.hasOwnProperty(key)) {
            sum += parseFloat(this.resultCartItem[key].price) * parseFloat(this.resultCartItem[key].rewardPrice)
          }
        }
        return sum
      },
    },
    methods: {
      ...mapActions('betting', [
        'emptyStakes',
        'addNumberToStake',
        'removeNumberFromStake'
      ]),
      reportUrl:function () {
        return window.location.href=(!this.offline?'/member/reports/space-lotto':'space-lotto/stake-sets')
      },
      selectAll: function (event) {
        setTimeout(function () {
          event.target.select()
        }, 0)
      },
      removeAllCartItems: function () {
        // var $this = this
        this.$swal({
          title: this.$t('messages.confirmClear'),
          text: this.$t('messages.clearAll'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#ed5565',
          // cancelButtonColor: '#ed5565',
          confirmButtonText: this.$t('messages.confirm'),
          cancelButtonText: this.$t('messages.close')
        }).then(() => {
          this.emptyStakes()
        })
      },
      randomNumber: function () {
        this.disableBtnRandomNumber = true
        this.currentNumber = ''
        var possible = '0123456789'
        var i = 1

        this.currentNumber += possible.charAt(Math.floor(Math.random() * possible.length))
        var numberInterval = setInterval(function () {
          this.currentNumber += possible.charAt(Math.floor(Math.random() * possible.length))
          i = i + 1
          if (i >= 6) {
            clearInterval(numberInterval)
            this.disableBtnRandomNumber = false
            if (_.includes(this.numberList, this.currentNumber)) {
              this.randomNumber()
            }
          }
        }.bind(this), 150)

      },
      removeCartItem (item) {
        this.removeNumberFromStake(item)
      },
      selectNumber: function (number, event) {
        if (this.currentNumber.length < 6) {
          this.currentNumber = this.currentNumber + number.toString()
        }
      },
      createCartItemObject: function (price) {
        var number = this.currentNumber

        if (number.length !== 6) {
          return
        }
        console.log(this.maxbet);
        if (this.selectPrice < 1 || this.selectPrice > this.maxbet) {
          this.notifyError(`กรุณาวางเงินเดิมพันต่ำที่สุด 1 บาทและสูงสุด ${this.maxbet}`);
          return;
        }

        var type = 1
        var min_bet_price = this.betconfig.patternObj.bet_space_lottery.stake_min
        var max_bet_price = this.betconfig.patternObj.bet_space_lottery.stake_max

        var limit = price == min_bet_price ? 1 : 2

        var slug = this.betDetails[type]['slug']
        var rewardPrice = this.betDetails[type]['rewardPrice']
        const data = {
          type: type,
          slug: slug,
          number: number,
          price: price,
          title: this.betDetails[type]['name'],
          rewardPrice: rewardPrice,
          minimumBetPrice: this.betDetails[type]['minimumBetPrice'],
          maximumBetPrice: this.betDetails[type]['maximumBetPrice'],
          maximumBetPricePerNumber: this.betDetails[type]['maximumBetPricePerNumber'],
          maximumNumberQuantityPerList: this.betDetails[type]['maximumNumberQuantityPerList'],
        }
        this.addNumberToStake(data)

        this.currentNumber = ''
      },
      cartGroupList: function () {
        var list = []
        if (!_.isNull(this.cartItem)) {
          for (var i = 1; i <= 8; i++) {

            if (_.find(this.cartItem, {type: i})) {
              list.push({
                name: this.betDetails[i].name,
                data: _.filter(this.cartItem, {type: i})
              })
            }
          }
        }
        return list
      },
      confirmCheckout: function () {
        $('#modal-confirm-checkout').modal('show')
      },
      doConfirmCheckout: function () {
        var $this = this
        this.resultCartItem = this.cartItem

        var dataSave = {
          stake_method: this.stakeMethod,
          bet_category_id: this.betconfig.id,
          period_id: this.betconfig.period.id,
          betListJsonStringify: JSON.stringify(this.cartItem)
        }

        if(this.offline){
          dataSave.mobile = this.mobile
          dataSave.email = this.email
        }
        window.axios.defaults.baseURL = '',
          axios.post('/api/auto-lotto/betting', dataSave).then((response) => {
            this.disableBtn = false
            if (response.status === 200) {
              console.log(response.data);
              this.stakeSetId = response.data.id[0]
              this.slipNumber = response.data.slipNumber
              this.resultCartItem = [...response.data.acceptedNumberData];
              this.errorItem = [...response.data.errorNumberData];
              this.forcePrice = null
              $('#modal-confirm-checkout').modal('hide')
              $('#modal-checkout-success').modal('show')
              this.emptyStakes()
              this.mobile = null
              this.email = null
              $('.credit-desktop-box, .credit-mobile-box').trigger('click')
            } else {
              var errorsHtml = $this.$t('messages.error')
              this.notifyError(errorsHtml)
            }

          }).catch(function (error) {
            if(error.response.request.status===401){
              var errorHtmlLogin = 'กรุณาทำการ <strong><a href="/login?redirect=/games/auto-lotto">เข้าสู่ระบบ</a></strong>'
              $this.notifyWarning(errorHtmlLogin)
              $('#modal-confirm-checkout').modal('hide')
              $this.disableBtn = false
              return
            }

            $('#modal-confirm-checkout').modal('hide')
            $this.disableBtn = false
            var errorsHtml = $this.$t('messages.error')
            if (!_.isNil(error.response.data.error)) {
              errorsHtml = '<div>' + error.response.data.error.message + '</div>'
            } else if (_.isArray(error.response.data)) {
              var errorsHtml = ''
              var errorList = error.response.data
//              for (var key in errorList) {
                if (errorList.hasOwnProperty(0)) {
                  errorsHtml += '<div>' + errorList[0].message + '</div>'
                }
//              }
              // errorsHtml +='<div>กรุณาติดต่อเจ้าหน้าที่ด้วยข้อความด้านบน</div>'
            }
            $this.notifyError(errorsHtml)
          })

      },
      notifyError: function (message) {
        this.$swal({
          title: 'เกิดข้อผิดพลาด!',
          // text: message,
          type: 'error',
          // showConfirmButton: false,
          // showCancelButton: true,
          confirmButtonColor: '#ec4758',
          cancelButtonText: 'OK',
          html: message
        })

        return false
      },
      notifyWarning: function (message) {
        this.$swal({
          // title: "แจ้งเตือน!",
          // text: message,
          type: 'warning',
           showConfirmButton: false,
           showCancelButton: false,
          html: message
        })

        return false
      }
    },
    created: function () {

    },
    mounted: function () {
    }
  }
</script>
<style>
  .font-19 {
    font-size: 19px;
  }

  .txt-bold {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/autolotto/pages/Game.vue